import {Component, Directive, Input, NgModule} from '@angular/core';

@Component({
  selector: 'sd-datepicker',
  exportAs: 'sdDatepicker',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'hidden'},
})
export class SdDatepicker<D = Date> {
  @Input() color: string | undefined;
}

@Component({
  selector: 'sd-datepicker-toggle',
  standalone: true,
  template: `<button type="button" class="inline-flex items-center text-[var(--m365-text-secondary,#6b6b70)]" (click)="open()"><span class="material-icons text-xl">calendar_today</span></button>`,
})
export class SdDatepickerToggle<D = Date> {
  @Input() for: SdDatepicker<D> | null = null;
  @Input('for') sdDatepicker: SdDatepicker<D> | null = null;
  input?: HTMLInputElement | null;

  open(): void {
    const input = this.input;
    if (input && 'showPicker' in input && typeof input.showPicker === 'function') {
      try {
        input.showPicker();
      } catch {
        input.focus();
      }
    } else {
      input?.focus();
    }
  }
}

@Directive({
  selector: '[sdDatepicker]',
  standalone: true,
  host: {
    type: 'date',
    class: 'sd-date-input',
  },
})
export class SdDatepickerInput<D = Date> {
  @Input() sdDatepicker: SdDatepicker<D> | null = null;
}

@Directive({
  selector: 'sd-datepicker-actions',
  standalone: true,
})
export class SdDatepickerActions {}

@Directive({
  selector: '[sdDatepickerCancel]',
  standalone: true,
})
export class SdDatepickerCancel {}

@Directive({
  selector: '[sdDatepickerApply]',
  standalone: true,
})
export class SdDatepickerApply {}

@NgModule({
  imports: [
    SdDatepicker,
    SdDatepickerToggle,
    SdDatepickerInput,
    SdDatepickerActions,
    SdDatepickerCancel,
    SdDatepickerApply,
  ],
  exports: [
    SdDatepicker,
    SdDatepickerToggle,
    SdDatepickerInput,
    SdDatepickerActions,
    SdDatepickerCancel,
    SdDatepickerApply,
  ],
})
export class SdDatepickerModule {}
